import script from "./ScTree.vue?vue&type=script&lang=ts"
export * from "./ScTree.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__